import React from 'react';
import { MOCK_ORDERS } from '../../data/mockData';
import { OrderCard } from '../OrderCard';
import { useToast } from '../ToastContext';
export function OrdersScreen() {
  const {
    showToast
  } = useToast();
  const activeOrder = MOCK_ORDERS.find(o => o.status !== 'completed');
  const pastOrders = MOCK_ORDERS.filter(o => o.status === 'completed');
  const handleReorder = () => {
    showToast('Items added to cart!', 'success');
  };
  return <div className="pb-24 pt-6 px-4 animate-in fade-in duration-500" data-id="element-1180">
      <h1 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-1181">Your Orders</h1>

      {activeOrder && <div className="mb-8" data-id="element-1182">
          <h2 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3" data-id="element-1183">
            Active Order
          </h2>
          <OrderCard order={activeOrder} data-id="element-1184" />
        </div>}

      <div data-id="element-1185">
        <h2 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3" data-id="element-1186">
          Past Orders
        </h2>
        <div className="space-y-4" data-id="element-1187">
          {pastOrders.map(order => <OrderCard key={order.id} order={order} onReorder={handleReorder} data-id="element-1188" />)}
        </div>
      </div>
    </div>;
}